export default "__VITE_ASSET__64633c02__"